const authButtonTransitionDurationMs = 200;
const buttonWrapper = "_arab1v7mseo";
const email = "_araef1nns5";
const cta = "_arac1sslnrc";
const authButtonWrapper = "_araa1mjvqkt";
const authButton = "_araaj9qtd1";
const authButtonIconWrapper = "_araa3dd6yb";
const authButtonIcon = "_araamye0ze";
const spinner = "_arasa4md4l";

export { authButton, authButtonIcon, authButtonIconWrapper, authButtonTransitionDurationMs, authButtonWrapper, buttonWrapper, cta, email, spinner };
import "./atom.drive-export-button.style.linaria.module.css";
//# sourceMappingURL=atom.drive-export-button.style.js.map
